import './cartViewStyles.scss'
import { Step, useProductOrderContext } from '../../context'
import { HeaderView } from '../header-view/HeaderView'
import { CartItem } from './components/cart-item/CartItem'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton, SecondaryButton } from 'ui_kit_qmd'
import { buttonStyle } from 'components/product-order-popup/utils'
import { useCallback, useEffect, useRef } from 'react'
import { type CartItem as Item } from 'types/products/productTypes'
import { CartCostView } from './components/cart-cost-view/CartCostView'

type Props = {
  accountCredit: number
}
export const CartView = ({ accountCredit }: Props) => {
  const {
    cartItems,
    goForward,
    goToStep,
    goBack,
    setEditCartItemId,
    editCartItemId,
    previousCartStep,
    deliveryType,
    setSelectedOption,
    resetRefillsQuantity,
    setProduct,
    isMoudHomeDelivery,
    isMHT,
  } = useProductOrderContext()
  const backItem = useRef<Item | undefined>()
  const onAddMoreScripts = useCallback(() => {
    setSelectedOption(undefined)
    resetRefillsQuantity()
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setProduct(null)
    goToStep(isMoudHomeDelivery ? Step.VIEW_MOUD_DELIVERY_COMBINED_PRODUCTS : Step.VIEW_PRODUCTS_LIST)
  }, [goToStep, isMoudHomeDelivery, resetRefillsQuantity, setProduct, setSelectedOption])

  useEffect(() => {
    if (editCartItemId) backItem.current = cartItems.find((item) => item.CartId === editCartItemId)
    else backItem.current = cartItems[cartItems.length - 1]
    setEditCartItemId('')
  }, [cartItems, editCartItemId, setEditCartItemId])

  const onBackClick = useCallback(() => {
    if (previousCartStep.current) {
      goToStep(previousCartStep.current)
      previousCartStep.current = undefined
      return
    }
    if (cartItems.length === 0) {
      onAddMoreScripts()
      return
    }
    // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
    setEditCartItemId(backItem.current.CartId)
    goBack()
  }, [cartItems.length, goBack, goToStep, onAddMoreScripts, previousCartStep, setEditCartItemId])
  return (
    <div className='cart-view-container'>
      <HeaderView
        title='Order contents'
        subtitle={`${cartItems.length} item${cartItems.length === 1 ? '' : 's'}`}
        backClick={onBackClick}
      />
      <div className='cart-items-container'>
        {cartItems.map((item) => (
          <CartItem item={item} />
        ))}
        {cartItems.length === 0 ?
          <div className='cart-items-empty'>
            <div className='cart-no-scripts-text'>No scripts added yet.</div>
            <SecondaryButton
              useUpdatedStyle
              containerStyle={{ width: 180, borderWidth: 0, padding: 0, height: 40 }}
              btnText='Add more scripts'
              onPress={onAddMoreScripts}
            />
          </div>
        : deliveryType === 'home' ?
          <CartCostView accountCredit={accountCredit} />
        : null}
      </div>
      <div className='cart-buttons-container'>
        {cartItems.length > 0 && (
          <PrimaryButton useUpdatedStyle containerStyle={buttonStyle} btnText='Continue' onPress={goForward} />
        )}
        {isMHT ? <SecondaryButton
            useUpdatedStyle
            containerStyle={buttonStyle}
            btnText='Add more scripts'
            onPress={onAddMoreScripts}
          /> : null}
      </div>
    </div>
  )
}
